// Home's order (plan 2E R18), after Sierra's Bridge: Sierra's own widgets by id, then
// any other, in module order, so a new module's widget still shows. A renamed widget
// would go to the end, so test/bridge.test.ts pins that every id here exists.

export const BRIDGE_ORDER = ['ops.next', 'supply.stock', 'supply.ships', 'donations.requests', 'bank.summary', 'donations.incoming', 'supply.activity', 'donations.recent', 'supply.refinery', 'library.countdown', 'library.verify'] as const;

export function orderWidgets<T extends { id: string }>(widgets: readonly T[]): T[] {
  const rank = (widget: T) => {
    const index = (BRIDGE_ORDER as readonly string[]).indexOf(widget.id);
    return index === -1 ? BRIDGE_ORDER.length : index;
  };
  // Array.prototype.sort is stable: unlisted widgets keep module order.
  return [...widgets].sort((a, b) => rank(a) - rank(b));
}
